// import React from "react";
// import "./PrivacyPolicy.css";

// const PrivacyPolicy = () => {
//   return (
//     <div className="privacy-policy">
//       <h2 className="privacy-title">Privacy Policy</h2>

//       <p className="privacy-subtitle">
//         At Spirulina ("we", "our", "us"), your privacy is very important to us.
//         This Privacy Policy explains how we collect, use, disclose, and protect
//         your personal information when you visit our website or purchase our
//         products.
//       </p>

//       {/* Section 1 */}
//       <section id="1">
//         <h5 className="section-heading">1. Information We Collect</h5>
//         <p className="sub-heading">
//           We may collect the following types of information:
//         </p>

//         <ul className="list">
//           <li>
//             <span>Personal Information:</span>
//             <p>
//               Name, mobile number, email address, shipping address, and billing
//               details.
//             </p>
//           </li>

//           <li>
//             <span>Account Information:</span>
//             <p>Login details, referral details, and transaction history.</p>
//           </li>

//           <li>
//             <span>Order Information:</span>
//             <p>
//               Product purchased, order status, delivery details, and payment
//               method.
//             </p>
//           </li>

//           <li>
//             <span>Technical Information:</span>
//             <p>IP address, device type, browser information, and usage data.</p>
//           </li>
//         </ul>
//       </section>

//       {/* Section 2 */}
//       <section id="2">
//         <h5 className="section-heading">2. How We Use Your Information</h5>
//         <p className="sub-heading">We use your information to:</p>

//         <ul className="list">
//           <li>Process orders and deliver products</li>
//           <li>Activate and manage user accounts</li>
//           <li>Provide customer support and respond to inquiries</li>
//           <li>Manage referral and reward programs</li>
//           <li>
//             Send order updates, notifications, and important announcements
//           </li>
//           <li>Improve our products, services, and user experience</li>
//           <li>Comply with legal and regulatory requirements</li>
//         </ul>
//       </section>

//       {/* Section 3 */}
//       <section id="3">
//         <h5 className="section-heading">3. Sharing of Information</h5>
//         <p className="sub-heading">
//           We do not sell or rent your personal information. We may share
//           information only with:
//         </p>

//         <ul className="list">
//           <li>Trusted delivery and logistics partners</li>
//           <li>Payment gateway providers for secure transactions</li>
//           <li>Legal or regulatory authorities when required by law</li>
//         </ul>

//         <p className="sub-heading">
//           All third parties are required to maintain confidentiality and data
//           security.
//         </p>
//       </section>

//       {/* Section 4 */}
//       <section id="4">
//         <h5 className="section-heading">4. Data Security</h5>
//         <p className="sub-heading">
//           We implement reasonable security measures to protect your personal
//           data against unauthorized access, alteration, or disclosure. However,
//           no online platform is 100% secure, and we cannot guarantee absolute
//           security.
//         </p>
//       </section>

//       {/* Section 5 */}
//       <section id="5">
//         <h5 className="section-heading">5. Cookies & Tracking Technologies</h5>
//         <p className="sub-heading">
//           We may use cookies and similar technologies to:
//         </p>

//         <ul className="list">
//           <li>Enhance website and app functionality</li>
//           <li>Understand user behavior and preferences</li>
//           <li>Improve performance and user experience</li>
//         </ul>

//         <p className="sub-heading">
//           You can control cookies through your browser settings.
//         </p>
//       </section>

//       {/* Section 6 */}
//       <section id="6">
//         <h5 className="section-heading">6. User Rights</h5>
//         <p className="sub-heading">You have the right to:</p>

//         <ul className="list">
//           <li>Access and update your personal information</li>
//           <li>Request correction of incorrect data</li>
//           <li>
//             Request deletion of your account (subject to legal obligations)
//           </li>
//           <li>Opt out of promotional communications</li>
//         </ul>
//       </section>

//       {/* Section 7 */}
//       <section id="7">
//         <h5 className="section-heading">7. Children’s Privacy</h5>
//         <p className="sub-heading">
//           Our products and services are not intended for individuals under the
//           age of 18. We do not knowingly collect personal data from children.
//         </p>
//       </section>

//       {/* Section 8 */}
//       <section id="8">
//         <h5 className="section-heading">8. Third-Party Links</h5>
//         <p className="sub-heading">
//           Our website or app may contain links to third-party websites. We are
//           not responsible for the privacy practices or content of those
//           websites.
//         </p>
//       </section>

//       {/* Section 9 */}
//       <section id="9">
//         <h5 className="section-heading">9. Changes to This Privacy Policy</h5>
//         <p className="sub-heading">
//           We may update this Privacy Policy from time to time. Any changes will
//           be posted on this page with an updated date.
//         </p>
//       </section>
//     </div>
//   );
// };

// export default PrivacyPolicy;

import React, { useEffect } from "react";
import "./PrivacyPolicy.css";
import { useDispatch, useSelector } from "react-redux";
import {
  AllPrivacyPolicy,
  AllPrivacyPolicyContent,
} from "../../../features/admin/common/Slice";

const PrivacyPolicy = ({ activeTab }) => {
  const dispatch = useDispatch();

  const all_privacy_policy = useSelector(
    (state) => state?.common?.all_privacy_policy,
  );
  

  useEffect(() => {
    dispatch(AllPrivacyPolicy());
    dispatch(AllPrivacyPolicyContent());
  }, [dispatch]);

  const filteredPolicy = all_privacy_policy?.filter(
  (item) => item?.content_id == activeTab,
);

  return (
    <div className="privacy-policy">
      <h2 className="privacy-title">Privacy Policy</h2>

      {/* <p className="privacy-subtitle">
        At Spirulina ("we", "our", "us"), your privacy is very important to us.
        This Privacy Policy explains how we collect, use, disclose, and protect
        your personal information when you visit our website or purchase our
        products.
      </p> */}

      {/* {all_privacy_policy?.length > 0 ? (
        all_privacy_policy.map((item) => ( */}

      {/* {all_privacy_policy?.length > 0 ? (
        all_privacy_policy
          .filter((item) => item?.content_id  == activeTab)
          .map((item) => (
            <section id={item?.content_id} key={item?.id}>
              <h5 className="section-heading">{item?.title}</h5>

              {item?.description && (
                <p
                  className="sub-heading"
                  dangerouslySetInnerHTML={{ __html: item?.description }}
                />
              )}

              {item?.points && item?.points?.length > 0 && (
                <ul className="list">
                  {item?.points?.map((point, index) => (
                    <li key={index}>{point}</li>
                  ))}
                </ul>
              )}
            </section>
          ))
      ) : (
        <p className="text-center mt-4">Privacy Policy is not available</p>
      )} */}

      {filteredPolicy?.length > 0 ? (
      filteredPolicy.map((item) => (
        <section
          id={item?.content_id}
          key={item?.id}
        >
          <h5 className="section-heading">
            {item?.privacypolicycontent?.name}
          </h5>

          {item?.description && (
            <div
              className="sub-heading"
              dangerouslySetInnerHTML={{
                __html: item?.description,
              }}
            />
          )}
        </section>
      ))
    ) : (
      <p className="text-center mt-4">
        Privacy Policy is not available
      </p>
    )}
    </div>
  );
};

export default PrivacyPolicy;
